var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',{attrs:{"fill":_vm.color,"fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"none","fill-rule":"evenodd","stroke":_vm.color,"stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","d":"M1 13l6-6-6-6"}})])}
var staticRenderFns = []

export { render, staticRenderFns }